import { IdType, SharingData } from './schema/SharingData';
import { SharingInfo } from './schema/SharingInfo';
import { getSharingTipIdsList, SharingTipId } from './types/sharingTipId';
import { SharingTipInfo } from './types/SharingTipInfo';
import { SharingTipRecipientInfo } from './types/SharingTipRecipientInfo';
import { SharingTipAction } from './types/SharingTipAction';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SharingData", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded services
export const lazyGetSharingInformation = new LazyImport(lazyModule, m => m.getSharingInformation);

// delay loaded utils
export const lazyGetSharingIssuesForSharingData = new LazyImport(
    lazyModule,
    m => m.getSharingIssuesForSharingData
);
export const lazyGetInfoBarCreator = new LazyImport(lazyModule, m => m.getInfoBarCreator);

// export public actions
export { refreshExpirationDate } from './actions/publicActions';

export { RecipientPermissionInfo, GetPermissionInfoStatus } from './schema/RecipientPermissionInfo';

export {
    IdType,
    SharingTipId,
    SharingData,
    SharingInfo,
    SharingTipAction,
    SharingTipInfo,
    SharingTipRecipientInfo,
    getSharingTipIdsList,
};
